export const NoRecordsTranslations = {
  'eng': {
    noRecords: 'No records found.'
  },
  'hrv': {
    noRecords: 'Nema pronađenih podataka.'
  }
};
